import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionStaffEffects } from './competition-staff.effects'
import * as fromCompetitionStaff from './competition-staff.reducer'
import { CompetitionStaffSerializer } from './competition-staff.serializer'
import { CompetitionStaffService } from './competition-staff.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionStaff.FEATURE_NAME,
      fromCompetitionStaff.competitionStaffReducer
    ),
    EffectsModule.forFeature([CompetitionStaffEffects])
  ],
  providers: [
    CompetitionStaffService,
    {
      provide: CompetitionStaffSerializer,
      useClass: CompetitionStaffSerializer
    }
  ],
  declarations: []
})
export class CompetitionStaffModule {}
